import {TranslatableResourceType} from 'types';

import {TranslatableResourceTypesWithHandleTranslations} from './types';

export const translatableResourceTypesWithHandleTranslationsList: TranslatableResourceTypesWithHandleTranslations[] =
  [
    TranslatableResourceType.Product,
    TranslatableResourceType.OnlineStoreArticle,
    TranslatableResourceType.OnlineStorePage,
    TranslatableResourceType.Collection,
    TranslatableResourceType.OnlineStoreMenu,
  ];
